import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class MenuCollapseStateService {
  private _value = signal<boolean>(false);
  readonly value = this._value.asReadonly();

  public setState(value: boolean) {
    this._value.set(value);
  }
}
